import styled from 'styled-components';
import { PanelContainer } from '~/layouts/promo/components/Panel';
import {
	StyledDropdown,
	StyledSearchInput,
	StyledDropdownList,
	StyledDropdownItem,
} from '~/layouts/promo/components/Dropdown.styled';

export const Panel = styled(PanelContainer)`
	width: 660px;
	max-width: calc(95vw / var(--zoom-factor, 1));
	max-height: calc(95vh / var(--zoom-factor, 1));
	color: #fff;
	font-family: 'GT Walsheim Pro';
	input[type='number'] {
		appearance: textfield;
		&::-webkit-inner-spin-button,
		&::-webkit-outer-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
	button:focus-visible,
	input:focus-visible,
	select:focus-visible {
		outline: 2px solid #2d70da;
		outline-offset: 2px;
	}
`;
export const Content = styled.div`
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
	> button {
		width: auto;
		flex-shrink: 0;
		white-space: nowrap;
	}
	> input {
		min-width: 0;
	}
`;
export const Fields = styled.div`
	display: grid;
	grid-template-columns: 1fr 1.2fr 1fr;
	gap: 12px;
`;
export const Field = styled.label`
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
	font-size: 14px;
	color: #b5b8bc;
`;
export const Coordinates = styled(Row)`
	> label {
		width: 52px;
		flex-shrink: 0;
		font-size: 14px;
		color: #b5b8bc;
	}
	> div {
		flex: 1;
		min-width: 0;
	}
`;
export const Options = styled(StyledDropdownList)`
	overflow-x: hidden;
`;
export const Option = styled(StyledDropdownItem).attrs({
	as: 'button',
	type: 'button',
})`
	display: block;
	width: 100%;
	box-sizing: border-box;
	border: 0;
	font: inherit;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
export const InteriorInput = styled(StyledSearchInput)`
	height: 40px;
	font-size: 16px;
	&::placeholder {
		color: #909499;
	}
`;
export const InteriorDropdown = styled(StyledDropdown)`
	top: calc(100% + 4px);
	bottom: auto;
	font-size: 16px;
`;
export const Footer = styled(Row)`
	padding: 16px 20px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	justify-content: space-between;
	> span {
		font-size: 14px;
		color: #b5b8bc;
	}
`;
export const Screenshot = styled.img`
	width: 100%;
	max-height: 190px;
	object-fit: contain;
	border-radius: 6px;
`;
